var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverBehaviour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5C9.57107 10.5 11.25 8.82107 11.25 6.75C11.25 4.67893 9.57107 3 7.5 3C5.42893 3 3.75 4.67893 3.75 6.75C3.75 8.82107 5.42893 10.5 7.5 10.5Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 18C1.25 18 0 18 0 16.75C0 15.5 1.25 11.75 7.5 11.75C13.75 11.75 15 15.5 15 16.75C15 18 13.75 18 13.75 18H1.25Z",
    fill: "#9B9B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 4.875C13.75 4.52982 14.0298 4.25 14.375 4.25H19.375C19.7202 4.25 20 4.52982 20 4.875C20 5.22018 19.7202 5.5 19.375 5.5H14.375C14.0298 5.5 13.75 5.22018 13.75 4.875Z",
    fill: "#9B9B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 8C14.0298 8 13.75 8.27982 13.75 8.625C13.75 8.97018 14.0298 9.25 14.375 9.25H19.375C19.7202 9.25 20 8.97018 20 8.625C20 8.27982 19.7202 8 19.375 8H14.375Z",
    fill: "#9B9B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 11.75C16.5298 11.75 16.25 12.0298 16.25 12.375C16.25 12.7202 16.5298 13 16.875 13H19.375C19.7202 13 20 12.7202 20 12.375C20 12.0298 19.7202 11.75 19.375 11.75H16.875Z",
    fill: "#9B9B9B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 15.5C16.5298 15.5 16.25 15.7798 16.25 16.125C16.25 16.4702 16.5298 16.75 16.875 16.75H19.375C19.7202 16.75 20 16.4702 20 16.125C20 15.7798 19.7202 15.5 19.375 15.5H16.875Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverBehaviour);
export default __webpack_public_path__ + "static/media/driver-behaviour.e7f4d48ba2d9af919c2d107182d10bda.svg";
export { ForwardRef as ReactComponent };